import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class NameCardService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.NAME_CARD = '/api/name-card';
    
        this.GET_BY_ID = '/{id}';
        this.GET_LIST_BY_PROJECT = '/list/project/{projectId}';
        this.GET_LIST_FILTERED = '/list/filtered';
    }

    async getListFiltered(filterMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.NAME_CARD + this.GET_LIST_FILTERED;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filterMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getByIdFetch(id) {
        try {
            let url = window.location.origin + this.NAME_CARD + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getById(id) {
        let cacheObj = localStorage.getItem('nameCardCache');
        if(!!cacheObj) {
            cacheObj = JSON.parse(cacheObj);
            let obj = cacheObj[id];
            if(!!obj) {
                obj = {
                    'body': JSON.stringify(obj)
                }
                return obj;
            }
        } else {
            cacheObj = {};
        }
        let fetchObj = await this.getByIdFetch(id);
        if(!!fetchObj?.body){
            let retObj = JSON.parse(fetchObj.body);
            cacheObj[id] = retObj;
            localStorage.setItem('nameCardCache', JSON.stringify(cacheObj));
        }
        return fetchObj;
    }

    async getListByProject(projectId) {
        try {
            let url = window.location.origin + this.NAME_CARD + this.GET_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async createNameCard(body) {
        try {
            let url = window.location.origin + this.NAME_CARD;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async updateNameCard(body) {
        try {
            let url = window.location.origin + this.NAME_CARD;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async deleteNameCard(body) {
        try {
            let url = window.location.origin + this.NAME_CARD;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }
}

export default NameCardService;
